export const isRequired = (value, message) => (!value ? message : '');

export const isOnlyLetter = (value, message) => {
  const regex = /^[a-z A-Z]+$/;
  return !regex.test(value) ? message : '';
};

export const isOnlyNumber = (value, message) => {
  const regex = /^[0-9]+$/;
  return !regex.test(value) ? message : '';
};

export const isEmail = (value, message) => {
  const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  return !regex.test(value) ? message : '';
};

export const isMinChar = (number, value, message) => {
  return value.length < number ? message : '';
};

export const isExactChar = (number, value, message) => {
  const length = value.length;
  return length < number || length > number ? message : '';
};

export const specialChars = (value) => {
  const symbol = new Set('!@#$%^&*()_+-=[]{};\':"\\|,.<>/?`~');
  return [...value].some(char => symbol.has(char));
};

export const upperCaseLetter = (value) => {
  const letter = new Set('ABCDEFGHIJKLMNOPQRSTUVWXYZ');
  return [...value].some(char => letter.has(char));
};

export const lowerCaseLetter = (value) => {
  const lowerLetter = new Set('abcdefghijklmnopqrstuvwxyz');
  return [...value].some(char => lowerLetter.has(char));
};

export const number = (value) => {
  const num = new Set('0123456789');
  return [...value].some(char => num.has(char));
};

export const passwordStrength = (value) => {
  let strength = 0;

  const isMinimum = value.length >= 8;

  if (isMinimum) {
    strength += 1;
  }
  if (isMinimum && upperCaseLetter(value)) {
    strength += 1;
  }
  if (isMinimum && lowerCaseLetter(value)) {
    strength += 1;
  }
  if (isMinimum && number(value)) {
    strength += 1;
  }
  if (isMinimum && specialChars(value)) {
    strength += 1;
  }

  return strength;
};

export const isEqualValue = (value, actualValue, message) => {
  return value !== actualValue ? message : '';
};

export const dynamicSort = (property) => {
  let sortOrder = 1;
  if(property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (firstArray,secondArray) {
    let result;
    if (firstArray[property] < secondArray[property]) {
      result = -1;
    } else if (firstArray[property] > secondArray[property]) {
      result = 1;
    } else {
      result = 0;
    }
    return result * sortOrder;
  };
};
export function isAppleDevice() {
  const userAgent = window.navigator.userAgent || window.opera;

  // Check if the device is iOS (iPhone, iPad, or iPod)
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  // Check if the platform is macOS
  const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent);

  return isIOS || isMac;
}
